import {useRef} from 'react'
import {useParams} from 'react-router-dom'

import Style from './style'

import usePostEventMove from 'entity/event/usePostEventMove'
import useGetEventDetail from 'entity/event/useGetEventDetail'

import DefaultModal from 'shared/ui/DefaultModal'
import DefaultButton from 'shared/ui/DefaultButton'

const ChangeTimerModal = ({closeEvent}) => {
	const {idx} = useParams()
	const levelRef = useRef()
	const minuteRef = useRef()
	const secRef = useRef()

	const [eventData] = useGetEventDetail()
	const [putTimer] = usePostEventMove(levelRef, minuteRef, secRef)

	// Parse duration list to get level options
	const getLevelOptions = () => {
		if (!eventData?.data?.duration_list) return []

		const durationList = Array.isArray(eventData.data.duration_list)
			? eventData.data.duration_list
			: JSON.parse(eventData.data.duration_list)

		let breakCount = 0
		return durationList.map((item, index) => {
			const [level, minutes] = item
			if (level === 'break') {
				breakCount++
				if (breakCount === 1) {
					return {
						value: 'break',
						label: `Break (${minutes}분)`,
						isBreak: true,
					}
				} else {
					return {
						value: `break${breakCount}`,
						label: `Break (${minutes}분)`,
						isBreak: true,
					}
				}
			} else {
				return {
					value: level,
					label: `Level ${level} (${minutes}분)`,
					isBreak: false,
				}
			}
		})
	}

	const levelOptions = getLevelOptions()

	return (
		<DefaultModal title='레벨 이동' closeEvent={closeEvent}>
			<Style.Wrapper>
				<Style.DivContainer>
					<select ref={levelRef} defaultValue=''>
						<option value='' disabled>
							레벨 선택
						</option>
						{levelOptions.map((option, index) => (
							<option key={index} value={option.value}>
								{option.label}
							</option>
						))}
					</select>
					<input placeholder='분 입력' ref={minuteRef} />
					<input placeholder='초 입력' ref={secRef} />
				</Style.DivContainer>
				<DefaultButton small fitWidth clickEvent={putTimer}>
					적용
				</DefaultButton>
			</Style.Wrapper>
		</DefaultModal>
	)
}

export default ChangeTimerModal
